const getters = {
  existChatVisor(state) {
    return (supervisorId) => {
      const index = state.chats.findIndex(
        (chat) => chat.supervisorId === supervisorId,
      );
      return index != -1;
    };
  },
  haveChatVisor(state) {
    return state.chats.length > 0;
  },
};

export default getters;
